/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeAllOrganizationRemoteSessionClientSessionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type RevokeAllOrganizationRemoteSessionClientSessionsRequest = {
  /**
   * The remote_session_client id.
   */
  clientId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type RevokeAllOrganizationRemoteSessionClientSessionsSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const RevokeAllOrganizationRemoteSessionClientSessionsSecurity$outboundSchema:
  z.ZodMiniType<
    RevokeAllOrganizationRemoteSessionClientSessionsSecurity$Outbound,
    RevokeAllOrganizationRemoteSessionClientSessionsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function revokeAllOrganizationRemoteSessionClientSessionsSecurityToJSON(
  revokeAllOrganizationRemoteSessionClientSessionsSecurity:
    RevokeAllOrganizationRemoteSessionClientSessionsSecurity,
): string {
  return JSON.stringify(
    RevokeAllOrganizationRemoteSessionClientSessionsSecurity$outboundSchema
      .parse(revokeAllOrganizationRemoteSessionClientSessionsSecurity),
  );
}

/** @internal */
export type RevokeAllOrganizationRemoteSessionClientSessionsRequest$Outbound = {
  client_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const RevokeAllOrganizationRemoteSessionClientSessionsRequest$outboundSchema:
  z.ZodMiniType<
    RevokeAllOrganizationRemoteSessionClientSessionsRequest$Outbound,
    RevokeAllOrganizationRemoteSessionClientSessionsRequest
  > = z.pipe(
    z.object({
      clientId: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        clientId: "client_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function revokeAllOrganizationRemoteSessionClientSessionsRequestToJSON(
  revokeAllOrganizationRemoteSessionClientSessionsRequest:
    RevokeAllOrganizationRemoteSessionClientSessionsRequest,
): string {
  return JSON.stringify(
    RevokeAllOrganizationRemoteSessionClientSessionsRequest$outboundSchema
      .parse(revokeAllOrganizationRemoteSessionClientSessionsRequest),
  );
}
